export default __webpack_public_path__ + "static/bluestone-0409f6d0f780bc01f41b9835f05bda9b.svg";